import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { refreshProductList, closeProductModal } from "../../redux/features/productModalSlice";
import { addUser } from "../../redux/services/User Services/User.Services";
import { ActiveCategoryList } from "../../redux/services/categoriesService/categories.Services";
import { ActiveSubCategoryList } from "../../redux/services/subCategoriesService/subCategories.Services";
import { ModuleList } from "../../redux/services/moduleService/module.Services";
import { successToast, errorToast } from "../../Utils/toast";
import { useDispatch, useSelector } from "react-redux";
function CreateClint({ data, isModal = false }) {
    const dispatch = useDispatch()
    const [errors, setErrors] = useState({});
    const { refreshData } = useSelector(
        (state) => state.staffModal
    );
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    // const [roles, setRoles] = useState([]);
    const [moduleList, setModuleList] = useState([]);

    const [formData, setFormData] = useState({
        name: "",
        mobile: "",
        email: "",
        password: "",
        category_id: "",
        gst: "",
        adharfront: null,
        PanNumber: "",
        adharback: null,
        module_id: "",
        business_name: "",
        subcategory_id: "",
        status: 1,
    });
    
const permissionsList = [
    {
        label: "Employees",
        key: "employees",
        children: [
            { label: "Employee", key: "staff" },
            { label: "Roles", key: "role" },
            { label: "Departments", key: "department" },
            { label: "Activity", key: "StaffActivity" },
        ],
    },
    {
        label: "Leads",
        key: "lead",
        children: [
            { label: "New", key: "newlead" },
            { label: "Pending", key: "pendinglead" },
            { label: "Others", key: "alllead" },
            { label: "Assigned Lead", key: "LeadAssigned" },
        ],
    },
    {
        label: "Dashboard",
        key: "dashboard",
    },
    {
        label: "Inventory Management",
        key: "inventoryManagement",
        children: [
            { label: "Categories", key: "category" },
            { label: "Sub Categories", key: "subcategory" },

        ],
    },
    {
        label: "Task",
        key: "task",
    },
    {
        label: "Chat",
        key: "chat",
    },
    {
        label: "Reminder",
        key: "reminder",
    },
    {
        label: "Meeting",
        key: "meeting",
    },
    {
        label: "Leave",
        key: "leave",
    },
    {
        label: "Calendar",
        key: "calendar",
    },
    {
        label: "Content / Setting",
        key: "settings",
    },
];
const defaultPermissions = permissionsList.reduce((acc, item) => {
    acc[item.key] = 0;
    if (item.children) {
        item.children.forEach(child => {
            acc[child.key] = 0;
        });
    }
    return acc;
}, {});
    const getDropdownData = async () => {
        try {
            const catResponse = await ActiveCategoryList();
            if (catResponse?.success) {
                setCategories(catResponse.data || []);
            }
            const moduleResponse = await ModuleList();
            if (moduleResponse?.success) {
                setModuleList(moduleResponse?.data || []);
            }
            else if (moduleResponse?.data?.success) {
                setModuleList(moduleResponse?.data?.data || []);
            }
            else { setModuleList([]); }
        } catch (error) {
            console.log("Error fetching dropdown data:", error);
            errorToast("Failed to load dropdown data");
        }
    };

    useEffect(() => {
        getDropdownData();
        // fetchRoles();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
        if (errors[name]) {
            setErrors((prev) => ({
                ...prev,
                [name]: null,
            }));
        }
    };
   const getParentCheckState = (parentKey) => {
        const parentItem = permissionsList.find(item => item.key === parentKey);
        if (!parentItem?.children) return false;

        const children = parentItem.children;
        const checkedCount = children.filter(
            child => formData.permissions[child.key] === 1
        ).length;

        if (checkedCount === 0) return false;
        if (checkedCount === children.length) return true;
        return 'indeterminate';
    };
   const handlePermissionTogglecheck = (key, children = []) => {
        setFormData((prev) => {
            const updatedPermissions = { ...prev.permissions };
            const isChecked = updatedPermissions[key] === 1 ? 0 : 1;

            // If it's a parent with children
            if (children.length > 0) {
                // Toggle parent
                updatedPermissions[key] = isChecked;
                children.forEach((child) => {
                    updatedPermissions[child.key] = isChecked;
                });
            } else {
                updatedPermissions[key] = isChecked;
                const parentItem = permissionsList.find(item =>
                    item.children?.some(child => child.key === key)
                );

                if (parentItem) {
                    const allChildrenChecked = parentItem.children.every(
                        child => updatedPermissions[child.key] === 1
                    );
                    const anyChildChecked = parentItem.children.some(
                        child => updatedPermissions[child.key] === 1
                    );
                    if (allChildrenChecked) {
                        updatedPermissions[parentItem.key] = 1;
                    } else if (!anyChildChecked) {
                        updatedPermissions[parentItem.key] = 0;
                    }
                }
            }

            return {
                ...prev,
                permissions: updatedPermissions,
            };
        });
    };
    
    const handleSelectAll = (e) => {
        const isChecked = e.target.checked;
        setFormData((prev) => {
            const updatedPermissions = { ...prev.permissions };

            // Update all permissions (both parent and child)
            Object.keys(updatedPermissions).forEach((key) => {
                updatedPermissions[key] = isChecked ? 1 : 0;
            });

            return {
                ...prev,
                permissions: updatedPermissions,
            };
        });
    };

    const isAllSelected = () => {
        return Object.values(formData.permissions).every(val => val === 1);
    };

    const isAnySelected = () => {
        return Object.values(formData.permissions).some(val => val === 1);
    };

    const handleCategoryChange = async (e) => {
        const categoryId = e.target.value;
        setFormData((prev) => ({
            ...prev,
            category_id: categoryId,
            subcategory_id: "",
            module_id: "",
        }));

        if (errors.category_id) {
            setErrors((prev) => {
                const updated = { ...prev };
                delete updated.category_id;
                return updated;
            });
        }
        if (categoryId) {
            try {
                const subResponse = await ActiveSubCategoryList(categoryId);
                if (subResponse?.data?.success) {
                    setSubCategories(subResponse.data.data || []);
                } else if (subResponse?.success) {
                    setSubCategories(subResponse.data || []);
                } else {
                    setSubCategories([]);
                }
            } catch (error) {
                console.log("Error fetching subcategories:", error);
                setSubCategories([]);
            }
        } else {
            setSubCategories([]);
        }
    };
    const handleFileChange = (e) => {
        const { name, files } = e.target;
        const file = files?.[0] || null;
        setFormData((prev) => ({ ...prev, [name]: file, }));
        if (errors[name]) {
            setErrors((prev) => {
                const updated = { ...prev };
                delete updated[name];
                return updated;
            });
        }
    };
      
    const validateForm = () => {
        const newErrors = {};
        if (!formData.name.trim()) {
            newErrors.name = ["Name is required"];
        }
        if (!formData.email.trim()) {
            newErrors.email = ["Email is required"];
        }
        if (!formData.password.trim()) {
            newErrors.password = ["Password is required"];
        }
        if (!formData.business_name.trim()) {
            newErrors.business_name = ["Business Name is required"];
        }
        if (!formData.subcategory_id.trim()) {
            newErrors.subcategory_id = ["SubCategory Name is required"];
        }
        if (!formData.category_id.trim()) {
            newErrors.category_id = ["Category Name is required"];
        }

        if (!formData.mobile.trim()) {
            newErrors.mobile = ["Mobile is required"];
        }

        setErrors(newErrors);
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const validationErrors = validateForm();

        if (Object.keys(validationErrors).length > 0) {
            setTimeout(() => {
                const firstErrorField = document.querySelector(".is-invalid");
                if (firstErrorField) {
                    firstErrorField.focus();
                    firstErrorField.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                    });
                }
            }, 100);
            return;
        }

        try {
            setLoading(true);

            // const payload = {
            //     name: formData.name,
            //     mobile: formData.mobile,
            //     email: formData.email,
            //     password: formData.password,
            //     status: formData.status,
            //     business_name: formData.business_name,
            //     category_id: formData.category_id,
            //     subcategory_id: formData.subcategory_id,
            // };

            const payload = new FormData();
            payload.append("name", formData.name);
            payload.append("mobile", formData.mobile);
            payload.append("email", formData.email);
            payload.append("password", formData.password);
            payload.append("business_name", formData.business_name);
            payload.append("category_id", formData.category_id);
            payload.append("subcategory_id", formData.subcategory_id);
            payload.append("module_id", formData.module_id);
            payload.append("gst", formData.gst);
            payload.append("PanNumber", formData.PanNumber);
            payload.append("status", formData.status);
            if (formData.adharfront) {
                payload.append("adharfront", formData.adharfront);
            }
            if (formData.adharback) {
                payload.append("adharback", formData.adharback);
            }
     Object.keys(formData.permissions).forEach((key) => {
                payload.append(
                    `permissions[${key}]`,
                    formData.permissions[key]
                );
            });          
            const res = await addUser(payload);
            if (res?.success === true) {
                successToast(res?.message || "user created successfully");
                refreshProductList()

                if (isModal) {
                    dispatch(closeProductModal());
                } else {
                    navigate("/user-list");
                }
            } else {
                errorToast(res?.message || "Something went wrong");
            }
        } catch (error) {
            console.log(error);
            if (
                error?.response?.data?.message &&
                typeof error.response.data.message === "object"
            ) {
                const validationErrors = error.response.data.message;
                setErrors(validationErrors);
                const allErrors = Object.values(validationErrors)
                    .flat()
                    .join(", ");
                errorToast(allErrors);
            } else {
                errorToast(
                    error?.response?.data?.errors ||
                    error?.response?.data?.message ||
                    "Failed to create staff"
                );
            }
        } finally {
            setLoading(false);
        }
    };
    return (
        <div className="main_page">
            <div className="card">
                <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h4>Add Vendor</h4>
                        <button
                            className="add-btn"
                            onClick={() => navigate(-1)}
                        >
                            Back
                        </button>
                    </div>
                    <form onSubmit={handleSubmit} className="row g-3">
                        <div className="col-md-6">
                            <label>Name <span className="text-danger">*</span></label>
                            <input
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                className={`form-control custumform ${errors?.name ? "is-invalid" : ""}`}
                            />
                            {errors?.name && (
                                <div className="invalid-feedback">
                                    {errors.name[0]}
                                </div>
                            )}
                        </div>
                        <div className="col-md-6">
                            <label>Email <span className="text-danger">*</span></label>
                            <input
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className={`form-control custumform ${errors?.email ? "is-invalid" : ""}`}
                            />
                            {errors?.email && (
                                <div className="invalid-feedback">
                                    {errors.email[0]}
                                </div>
                            )}
                        </div>
                        <div className="col-md-6">
                            <label>Mobile <span className="text-danger">*</span></label>
                            <input
                                name="mobile"
                                value={formData.mobile}
                                onChange={(e) => {
                                    const value = e.target.value.replace(/\D/g, "");
                                    setFormData((prev) => ({
                                        ...prev,
                                        mobile: value,
                                    }));
                                    if (errors.mobile) {
                                        setErrors((prev) => ({
                                            ...prev,
                                            mobile: null,
                                        }));
                                    }
                                }}
                                className={`form-control custumform ${errors?.mobile ? "is-invalid" : ""}`}
                                maxLength={10}
                            />
                            {errors?.mobile && (
                                <div className="invalid-feedback d-block">
                                    {errors.mobile[0]}
                                </div>
                            )}
                        </div>
                        <div className="col-md-6">
                            <label>Password <span className="text-danger">*</span></label>
                            <input
                                type="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                className={`form-control custumform ${errors?.password ? "is-invalid" : ""
                                    }`}
                            />
                            {errors?.password && (
                                <div className="invalid-feedback">
                                    {errors.password[0]}
                                </div>
                            )}
                        </div>

                        <div className="col-md-6">
                            <label>Business Name <span className="text-danger">*</span></label>
                            <input
                                name="business_name"
                                value={formData.business_name}
                                onChange={handleChange}
                                className={`form-control custumform ${errors?.business_name ? "is-invalid" : ""}`}
                            />
                            {errors?.business_name && (
                                <div className="invalid-feedback">
                                    {errors.business_name[0]}
                                </div>
                            )}
                        </div>

                        <div className="col-md-6 mb-3">
                            <label> Business Category <span className="text-danger">*</span></label>
                            <select
                                className={`form-control custumform ${errors.category_id ? "is-invalid" : ""}`}
                                name="category_id"
                                value={formData.category_id}
                                onChange={handleCategoryChange}
                            >
                                <option value="">Select Category</option>
                                {categories.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                            {errors.category_id && (
                                <small className="text-danger">{errors.category_id}</small>
                            )}
                        </div>

                        <div className="col-md-6 mb-3">
                            <label>Sub Category <span className="text-danger">*</span></label>
                            <select
                                className={`form-control custumform ${errors.subcategory_id ? "is-invalid" : ""}`}
                                name="subcategory_id"
                                value={formData.subcategory_id}
                                onChange={handleChange}
                            >
                                <option value="">Select SubCategory</option>
                                {subCategories.length > 0 ? (
                                    subCategories.map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.name}
                                        </option>
                                    ))
                                ) : (
                                    <option value="">No subcategories available</option>
                                )}
                            </select>
                            {errors.subcategory_id && (
                                <small className="text-danger">{errors.subcategory_id}</small>
                            )}
                        </div>




                        <div className="col-md-6 mb-3">
                            <label>Select Modules <span className="text-danger">*</span></label>
                            {/* <select
                                className={`form-control custumform ${errors.module_id ? "is-invalid" : ""}`}
                                name="module_id"
                                value={formData.module_id}
                                onChange={handleChange}
                                disabled={!formData.subcategory_id}
                            >
                                <option value="">Select Module</option>
                                {filteredModules.length > 0 ? (
                                    filteredModules.map((item) => (
                                        <option key={item.id} value={item.id}>{item.name}</option>
                                    ))
                                ) : (
                                    <option value="">No modules available</option>
                                )}
                            </select> */}
                            {errors.module_id && <small className="text-danger">{errors.module_id}</small>}
                        </div>



                        <div className="col-md-6">
                            <label> Adhar Card Front</label>
                            <input
                                type="file"
                                name="adharfront"
                                onChange={handleFileChange}
                                className="form-control custumform"
                            />
                            {/* {errors?.name && (
                                <div className="invalid-feedback">
                                    {errors.name[0]}
                                </div>
                            )} */}
                        </div>


                        <div className="col-md-6">
                            <label> Adhar Card Back</label>
                            <input
                                type="file"
                                name="adharback"
                                onChange={handleFileChange}
                                className="form-control custumform"
                            />

                        </div>
                            <div className="col-md-6">
                            <label> Pan Number</label>
                            <input
                                name="panNumber"
                                value={formData.PanNumber}
                                onChange={handleChange}
                                className="form-control custumform"
                            />

                        </div>
                        <div className="col-md-6">
                            <label> GST Number</label>
                            <input
                                name="gst"
                                value={formData.gst}
                                onChange={handleChange}
                                className="form-control custumform"
                            />

                        </div>



                        {/* <div className="col-md-6">
                            <label>Role <span className="text-danger">*</span></label>
                            <select
                                name="role"
                                value={formData.role}
                                onChange={handleChange}
                                className={`form-control custumform ${errors?.role ? "is-invalid" : ""}`}
                            >
                                <option value="">Select Role</option>
                                {roles?.map((role) => (
                                    <option key={role.id} value={role.name}>
                                        {role.name}
                                    </option>
                                ))}
                            </select>
                            {errors?.role && (
                                <div className="invalid-feedback d-block">
                                    {errors.role[0]}
                                </div>
                            )}
                        </div> */}
                        <div className="col-md-6">
                            <label>Status</label>
                            <select
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                                className="form-control"
                            >
                                <option value="1">Active</option>
                                <option value="0">Inactive</option>
                            </select>
                        </div>

                        {/* <div className="col-md-12">
                            <label>Address <span className="text-danger">*</span></label>
                            <textarea
                                name="address"
                                value={formData.address}
                                onChange={handleChange}
                                rows="3"
                                className={`form-control custumform ${errors?.address ? "is-invalid" : ""}`}
                            />
                            {errors?.address && (
                                <div className="invalid-feedback d-block">
                                    {errors.address[0]}
                                </div>
                            )}
                        </div> */}
                        {/* SUBMIT */}
                           <div className="row">
                                {permissionsList.map((item) => (
                                    <div key={item.key} className="col-md-4 mb-4">
                                        <div className="card shadow-sm border-0">

                                            {/* Header / Parent Permission */}
                                            <div className="card-header bg-light d-flex align-items-center">
                                                <div className="form-check m-0 w-100">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`perm-${item.key}`}
                                                        checked={formData.permissions[item.key] === 1}
                                                        ref={(el) => {
                                                            if (el && item.children) {
                                                                const state = getParentCheckState(item.key);
                                                                el.indeterminate = state === "indeterminate";
                                                            }
                                                        }}
                                                        onChange={() =>
                                                            handlePermissionTogglecheck(item.key, item.children || [])
                                                        }
                                                    />
                                                    <label
                                                        className="form-check-label fw-bold text-light ms-2"
                                                        htmlFor={`perm-${item.key}`}
                                                    >
                                                        {item.label}
                                                    </label>
                                                </div>
                                            </div>

                                            {/* Body / Children Permissions */}
                                            {item.children?.length > 0 && (
                                                <div className="card-body py-2">
                                                    <div className="ps-2 border-start">
                                                        {item.children.map((child) => (
                                                            <div key={child.key} className="form-check mb-2">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    id={`perm-${child.key}`}
                                                                    checked={formData.permissions[child.key] === 1}
                                                                    onChange={() =>
                                                                        handlePermissionTogglecheck(child.key, [])
                                                                    }
                                                                />
                                                                <label
                                                                    className="form-check-label text-light ms-2"
                                                                    htmlFor={`perm-${child.key}`}
                                                                >
                                                                    {child.label}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        <div className="col-12 text-end">
                            <button
                                type="submit"
                                className="add-btn"
                                disabled={loading}
                            >
                                {loading ? "Creating..." : "Create User"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
export default CreateClint;